import React, { useContext } from 'react'

import { Switch, Route, withRouter } from 'react-router-dom'
import { Routes } from '../routes'
import SchoolStudentsView from '../Views/school/StudentsPage/SchoolStudentsView.jsx'
import { getUser } from '../reducers/UserReducer'
import InstitutionsView from '../Views/school/InstitutionsView/InstitutionsView.jsx'
import ShiftPresetsManager from '../Views/shared/ShiftsPresetsManagerView/ShiftPresetsManager'
import ChangeLogView from '../Views/shared/ChangeLogView'
import TagsManagementView from '../Views/shared/TagsManagementView'
import ShiftsManagerView from '../Views/institution/InstitutionShiftManager'
import { connect } from 'react-redux'
import { isMoment } from 'moment'
import { GlobalContext } from '../Providers/GlobalProvider'
import SchoolProvider from '../Providers/SchoolProvider'
import SchoolSectionsView from '../Views/school/SchoolSectionsView/SchoolSectionsView'
import InternshipsView from '../Views/school/InternshipsView/InternshipsView'
import InstitutionDocumentsDrawer from '../Providers/Drawer/InstitutionDocumentsDrawer'
import ContactPersonsTabsView from '../Views/shared/ContactPersons/ContactPersonsTabsView'
import PlacesView from '../Views/school/Places/PlacesView'
import { isCoordinator, isEncoder, isSupervisor } from '../utils/roles'
import DefaultContainer from '../HOC/DefaultContainer'
import useBetaMode from '../hooks/useBetaMode'
import SchoolSettingsView from '../Views/school/SettingsView/SchoolSettingsView.jsx'
import MyProfileView from '../Views/shared/MyProfileView'

const mapStateToProps = state => ({ user: getUser(state.getUser) })

const SchoolRouter = ({ history, user }) => {
  const { currentDate, setCurrentDate } = useContext(GlobalContext)

  const betaMode = useBetaMode()

  const goToShiftManager = date => {
    history.push(Routes.SHIFTS_MANAGER)

    if (isMoment(date)) {
      setCurrentDate(date)
    }
  }

  return (
    <SchoolProvider>
      <Switch>
        <Route path={Routes.INTERNSHIPS}>
          <InternshipsView loadShiftsManager={goToShiftManager} />
        </Route>
        <Route path={Routes.STUDENTS}>
          <SchoolStudentsView />
        </Route>
        {!isSupervisor(user) && (
          <Route path={Routes.SCHOOL_SECTION}>
            <SchoolSectionsView />
          </Route>
        )}
        <Route path={Routes.INSTITUTIONS}>
          <InstitutionDocumentsDrawer>
            <InstitutionsView />
          </InstitutionDocumentsDrawer>
        </Route>
        {(isEncoder(user) || isCoordinator(user)) && (
          <Route path={Routes.SETTINGS}>
            <SchoolSettingsView />
          </Route>
        )}
        {betaMode.active && isEncoder(user) && (
          <Route path={Routes.QUOTAS}>
            <DefaultContainer useTabs={false}>
              <PlacesView />
            </DefaultContainer>
          </Route>
        )}
        <Route path={Routes.SHIFTS_MANAGER}>
          <ShiftsManagerView currentDate={currentDate} displayManagePresets={false} />
        </Route>
        {isEncoder(user) && (
          <Route path={Routes.PRESETS_MANAGER}>
            <ShiftPresetsManager
              sector={null}
            />
          </Route>
        )}
        <Route path={Routes.TAGS_MANAGEMENT}>
          <TagsManagementView />
        </Route>
        <Route path={Routes.PROFILE_PAGE}>
          <MyProfileView />
        </Route>
        <Route path={Routes.CHANGELOG}>
          <ChangeLogView />
        </Route>
        {(isEncoder(user) || isCoordinator(user)) && (
          <Route path={Routes.CONTACT_PERSONS}>
            <ContactPersonsTabsView />
          </Route>
        )}
      </Switch>
    </SchoolProvider>
  )
}

export default withRouter(connect(mapStateToProps)(SchoolRouter))
